// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"9f3a8d1b","57":"8da43be5","65":"a7378123","396":"40b337e7","457":"84a2f526","535":"ef8cf884","546":"0ddad7e9","670":"6929ebf0","764":"377c803f","789":"a04d1dce"}[chunkId] + ".chunk.js";
};